import { uniqBy } from 'lodash-es'

import {
  PersonalAccount,
  PersonalAccountType,
  Project,
  ProjectResponse,
  UserInfo,
  UserInfoResponse
} from './auth.types'

const normalizePersonalAccounts = (
  personalAccounts: PersonalAccount[]
): PersonalAccount[] =>
  personalAccounts.map(account => ({
    ...account,
    type: String(account.type).toLowerCase() as PersonalAccountType
  }))

const buildProject = (domain: ProjectResponse): Project => {
  const personalAccounts = normalizePersonalAccounts(domain.personalAccounts)

  return {
    bc_guid: domain.id,
    bc_name: domain.name,
    src: domain.src,
    personalAccounts,
    premises: uniqBy(
      personalAccounts.flatMap(account =>
        account.premises.map(premise => ({
          ...premise,
          number: account.number
        }))
      ),
      'id'
    ),
    allPremises: personalAccounts.flatMap(account =>
      account.premises.map(premise => ({
        ...premise,
        number: account.number
      }))
    )
  }
}

export const UserInfoMapper = {
  toEntity(domain: UserInfoResponse): UserInfo {
    return {
      name: domain.name,
      title: domain.title,
      email: domain.email,
      phone_number: domain.mobile_number,
      guid: domain.guid1c,
      isLegalEntity: domain.isLegalEntity,
      projects: domain.projects.map(project => buildProject(project))
    }
  }
}
